import * as types from "../../constants/actionTypes";

const initState = {
    isLoading: false,
    directURL: {
        isValid: undefined,
        hakAkses: ""
    },
    formLogin: {
        email: "",
        password: "",
    },
    formRegister: {
        f_email_userm: "",
        f_nama_userm: "",
        f_password_userm: "",
        f_password_userm_konfirmasi: "",
        f_telepon_userm: "",
    },
    formRegisterKlinik: {
        f_nama_klinik: "",
        f_email_klinik: "",
        f_telepon_klinik: "",
        f_no_alamat_klinik: "",
        f_temp_lokasi: [],
    },
    formVerifikasiPassword: {
        password: "",
        password_userm_konfirmasi: "",
    },

};

export default function (state = initState, action) {
    switch (action.type) {
        case types.MODULE_AUTH_SET_LOADER: {
            return{
                ...state,
                isLoading: action.value
            }
        }
        case types.MODULE_AUTH_CHECK_URL_SUCCESS: {
            return{
                ...state,
                directURL: action.value
            }
        }
        case types.MODULE_AUTH_INIT_FORM: {
            return {
                ...state,
                formLogin: initState.formLogin
            }
        }
        case types.MODULE_AUTH_INIT_FORM_REGISTER: {
            return {
                ...state,
                formRegister: initState.formRegister
            }
        }
        case types.MODULE_AUTH_INIT_FORM_REGISTER_KLINIK: {
            return {
                ...state,
                formRegisterKlinik: initState.formRegisterKlinik
            }
        }
        case types.MODULE_AUTH_INIT_FORM_VERIFIKASI_PASSWORD: {
            return {
                ...state,
                formVerifikasiPassword: initState.formVerifikasiPassword
            }
        }

        case types.MODULE_AUTH_HANDLE_STATE_FORM: {
            return {
                ...state,
                formLogin: {
                    ...state.formLogin,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_AUTH_HANDLE_STATE_FORM_REGISTER: {
            return {
                ...state,
                formRegister: {
                    ...state.formRegister,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_AUTH_HANDLE_STATE_FORM_REGISTER_KLINIK: {
            return {
                ...state,
                formRegisterKlinik: {
                    ...state.formRegisterKlinik,
                    [action.property]: action.value,
                }
            }
        }
        case types.MODULE_AUTH_HANDLE_STATE_FORM_VERIFIKASI_PASSWORD: {
            return {
                ...state,
                formVerifikasiPassword: {
                    ...state.formVerifikasiPassword,
                    [action.property]: action.value,
                }
            }
        }
        default:
            return {
                ...state
            }
    }
}  